let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("4gJkh")).then(() => parcelRequire('1lA3p'));